"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const BlogDirectory_1 = require("./BlogDirectory");
// This will return the routes for the <Router>
const BlogRoutes /*: { path: string; element: FunctionComponentElement<unknown> }[]*/ = BlogDirectory_1.BLOG_POSTS.map((blogItem) => {
    return {
        path: (0, BlogDirectory_1.urlForBlogItem)(blogItem),
        element: react_1.default.createElement(blogItem.content),
    };
});
exports.default = BlogRoutes;
